module.exports = __webpack_public_path__ + "43efb5ee656e99313ae7c72d3831a705.gif";